(() => {
  if (window.fdCollectionBrowseLoaded) return;
  window.fdCollectionBrowseLoaded = true;
  function init() {
    document.querySelectorAll('[data-fd-character-filter] .details__content').forEach(content => {
      const list = content.querySelector('ul.list');
      if (!list || content.querySelector('.fd-character-search')) return;
      const search = document.createElement('input');
      search.type = 'search';
      search.className = 'fd-character-search';
      search.placeholder = content.closest('[data-fd-character-filter]').dataset.searchLabel;
      search.setAttribute('aria-label', search.placeholder);
      list.classList.add('fd-character-options');
      content.prepend(search);
      const empty = document.createElement('p');
      empty.className = 'fd-character-empty';
      empty.textContent = content.closest('[data-fd-character-filter]').dataset.emptyLabel;
      empty.hidden = true;
      content.append(empty);
    });
    document.querySelectorAll('[data-fd-height-filter] .details__content').forEach(content => {
      const list = content.querySelector('ul.list');
      if (!list || content.querySelector('.fd-height-groups')) return;
      const root = content.closest('[data-fd-height-filter]');
      const buckets = [[], [], [], []];
      list.querySelectorAll('input[type="checkbox"]').forEach(input => {
        const value = input.value;
        const height = parseFloat(value);
        let group = 3;
        if (!/[&,]/.test(value) && Number.isFinite(height)) group = height < 20 ? 0 : height < 30 ? 1 : 2;
        input.dataset.heightGroup = String(group);
        buckets[group].push(input);
      });
      const groups = document.createElement('ul');
      groups.className = 'fd-height-groups';
      buckets.forEach((inputs, index) => {
        if (!inputs.length) return;
        const row = document.createElement('li');
        const label = document.createElement('label');
        const input = document.createElement('input');
        input.type = 'checkbox';
        input.className = 'checkbox';
        input.dataset.fdHeightGroup = String(index);
        input.checked = inputs.every(item => item.checked);
        input.indeterminate = !input.checked && inputs.some(item => item.checked);
        input.disabled = inputs.every(item => item.disabled);
        label.append(input, document.createTextNode(root.dataset['group' + index]));
        row.append(label);
        groups.append(row);
      });
      list.classList.add('fd-height-native');
      list.hidden = true;
      content.prepend(groups);
    });
  }
  document.addEventListener('input', event => {
    if (!event.target.matches('.fd-character-search')) return;
    event.stopPropagation();
    const content = event.target.parentElement;
    const query = event.target.value.trim().toLocaleLowerCase();
    let visible = 0;
    content.querySelectorAll('ul.list>li').forEach(row => {
      row.hidden = !row.textContent.toLocaleLowerCase().includes(query);
      if (!row.hidden) visible++;
    });
    content.querySelector('.fd-character-empty').hidden = visible > 0;
  }, true);
  document.addEventListener('change', event => {
    if (event.target.matches('.fd-character-search')) { event.stopPropagation(); return; }
    if (!event.target.matches('[data-fd-height-group]')) return;
    event.stopPropagation();
    const content = event.target.closest('.details__content');
    const inputs = [...content.querySelectorAll('.fd-height-native input')].filter(input => input.dataset.heightGroup === event.target.dataset.fdHeightGroup);
    inputs.forEach(input => {
      input.checked = event.target.checked;
      if (event.target.checked) input.disabled = false;
    });
    const changed = inputs.find(input => !input.disabled) || inputs[0];
    changed?.dispatchEvent(new Event('change', { bubbles: true }));
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Enter' && event.target.matches('.fd-character-search')) event.preventDefault();
  });
  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; init(); });
  });
  function start() { init(); observer.observe(document.querySelector('#MainContent'), { childList: true, subtree: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();


(() => {
 function initialiseCollectionDescriptions(){
  document.querySelectorAll('.fd-collection-about').forEach(details=>{
   if(details.dataset.toggleReady)return;
   details.dataset.toggleReady='true';
   const label=details.querySelector('.fd-collection-toggle');
   if(!label)return;
   const more=label.textContent;
   details.addEventListener('toggle',()=>{label.textContent=details.open?details.dataset.less:more;});
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialiseCollectionDescriptions,{once:true});else initialiseCollectionDescriptions();
 document.addEventListener('shopify:section:load',initialiseCollectionDescriptions);
})();
